export default __webpack_public_path__ + "static/media/OmaduroTorpedoOpen.16c2a398.jpg";